import React from "react";
import BranchAnalysisComponent from "../../components/branchAnalysisComponents/BranchAnalysisComponent";


const BranchAnalysisContainer: React.FC<{ isTabSelected: boolean }> = ({isTabSelected}) => {
    return(
        <BranchAnalysisComponent isTabSelected={isTabSelected} />
    )
};

export default BranchAnalysisContainer;
